import { roundToMultiple5, filterTableForCurrentAmount, convertValueFromLogarithmicBehaviour, convertValueToLogarithmicBehaviour, getCurrentPercentageFromProgressBar, getCurrentValueFromPercentage } from './utils';

const getSmallestMaxPaymentValueForCurrentAmount = (table, currentAmount) => {
  const tableRowsWithCurrentAmount = filterTableForCurrentAmount(table, currentAmount);

  const maxPaymentsList = tableRowsWithCurrentAmount.map(row => {
    return parseFloat(row["maxRata"].replace(",", "."));
  });

  const smallestMaxPaymentValue = Math.min(...maxPaymentsList);

  return smallestMaxPaymentValue;
}

const getMinPaymentValueForCurrentAmount = (table, currentAmount, smallestMaxPaymentValue) => {
  let minPayment = 9999;
  
  //Modified on 30/01/2023
  //All logic is unused following Gian simulator
  return smallestMaxPaymentValue;

  const tableRowsWithCurrentAmount = filterTableForCurrentAmount(table, currentAmount);

  tableRowsWithCurrentAmount.forEach(row => {
    const minPaymentOfTheRow = parseFloat(row["minRata"].replace(",", "."));
    
    if (minPaymentOfTheRow < minPayment && minPaymentOfTheRow >= smallestMaxPaymentValue) {
      minPayment = minPaymentOfTheRow;
    };
  })

  //Changed on 16-11-2022 by DM - amount 1000 return 9999 with previous condition;
  //if (minPayment === 9999 && tableRowsWithCurrentAmount.length === 1) {
  if (minPayment === 9999) {
    minPayment = parseFloat(tableRowsWithCurrentAmount[0]["maxRata"].replace(",", "."));
  }

  return minPayment;
}

const getMaxPaymentValueForCurrentAmount = (table, currentAmount) => {
  const tableRowsWithCurrentAmount = filterTableForCurrentAmount(table, currentAmount);

  const maxPaymentsList = tableRowsWithCurrentAmount.map(row => {
    return parseFloat(row["maxRata"].replace(",", "."));
  });

  const maxPayment = Math.max(...maxPaymentsList);

  return maxPayment;
}

const getMinNumberOfInstallmentsForCurrentAmount = (table, currentAmount) => {
  const tableRowsWithCurrentAmount = filterTableForCurrentAmount(table, currentAmount);

  const numberOfInstallmentsList = tableRowsWithCurrentAmount.map(row => {
    return parseFloat(row["NumRate"].replace(",", "."));
  });

  const minNumberOfInstallments = Math.min(...numberOfInstallmentsList);

  return minNumberOfInstallments;
}

const getMaxNumberOfInstallmentsForCurrentAmount = (table, currentAmount) => {
  const tableRowsWithCurrentAmount = filterTableForCurrentAmount(table, currentAmount);

  const numberOfInstallmentsList = tableRowsWithCurrentAmount.map(row => {
    return parseFloat(row["NumRate"].replace(",", "."));
  });

  const maxNumberOfInstallments = Math.max(...numberOfInstallmentsList);

  return maxNumberOfInstallments;
}

export const setPaymentDataFromCurrentAmount = function(data, callbacks) {
  const { table, currentAmount, payment } = data;
  const { setTableRecap, setPaymentSlider } = callbacks;

  const smallestMaxPaymentValue = getSmallestMaxPaymentValueForCurrentAmount(table, currentAmount);
  const minPayment = roundToMultiple5(getMinPaymentValueForCurrentAmount(table, currentAmount, smallestMaxPaymentValue));
  const maxPayment = roundToMultiple5(getMaxPaymentValueForCurrentAmount(table, currentAmount));
  
  // è corretto impostare minTAN e minTAEG con i valori dell'ultimo oggetto della tabella e non con quelli di un oggetto con importo corrente?
  setTableRecap({
    [currentAmount]: {
      minPayment: minPayment,
      maxPayment: maxPayment,
      minNumberOfInstallments: getMinNumberOfInstallmentsForCurrentAmount(table, currentAmount),
      maxNumberOfInstallments: getMaxNumberOfInstallmentsForCurrentAmount(table, currentAmount),
      minTAN: parseFloat(table[table.length - 1]["minTAN"].replace(",", ".")),
      maxTAN: 0,
      minTAEG: parseFloat(table[table.length - 1]["minTAEG"].replace(",", ".")),
      maxTAEG: 0,
    }
  });

  //Case return from riepilogo called by external simulator page
  if(payment.min === -1000) {
    payment.min = minPayment;
  }

  //Case return from riepilogo called by external simulator page
  if(payment.max === -1000) {
    payment.max = maxPayment;
  }

  const previousPaymentValue = convertValueFromLogarithmicBehaviour({ currentValue: payment.currentValue.shown, min: payment.min, max: payment.max, step: 1 }, 5);
  const previousPaymentPercentage = getCurrentPercentageFromProgressBar(previousPaymentValue, payment.min, payment.max);

  if (minPayment === maxPayment) {
    // Handle the payment slider as a pure percentage (min = 0, max = 100) and then put in front a layer with the real labels and current value
    const currentPaymentValue = getCurrentValueFromPercentage(0, 100, previousPaymentPercentage);

    const logarithmicCurrentValue = convertValueToLogarithmicBehaviour({
      currentValue: currentPaymentValue,
      min: 0,
      max: 100,
      step: 5
    },
    5);

    setPaymentSlider({
      currentValue: {
        real: currentPaymentValue,
        shown: logarithmicCurrentValue,
      },
      min: 0,
      max: 100,
      frontLayer: {
        currentValue: minPayment,
        min: minPayment,
        max: minPayment,
      }
    });
  } else {
    const currentPaymentValue = getCurrentValueFromPercentage(minPayment, maxPayment, previousPaymentPercentage);

    const logarithmicCurrentValue = convertValueToLogarithmicBehaviour({
      currentValue: currentPaymentValue,
      min: minPayment,
      max: maxPayment,
      step: 5
    },
    5);

    setPaymentSlider({
      currentValue: {
        real: currentPaymentValue,
        shown: logarithmicCurrentValue,
      },
      min: minPayment,
      max: maxPayment,
      frontLayer: {}
    });
  }
}